// FOOTER 
window.addEventListener('scroll', () => {
  const scrollTop = window.scrollY;
  const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
  const scrollPercent = (scrollTop / scrollHeight) * 100;
  
  const footer = document.querySelector("footer");

  if(scrollPercent > 80){
    footer.style.setProperty("position", "sticky", "important");  
  }else{
    footer.style.setProperty("position", "relative", "important");
  }
});


const wrapper = document.querySelector('.page-wrapper');

wrapper.addEventListener('scroll', () => {
  const scrollTop = wrapper.scrollTop;
  const scrollHeight = wrapper.scrollHeight - wrapper.clientHeight;
  const scrollPercent = (scrollTop / scrollHeight) * 100;
  const footer = document.querySelector("footer");
  if(scrollPercent > 80){
    footer.style.setProperty("position", "sticky", "important");  
  }else{
    footer.style.setProperty("position", "relative", "important");
  }
});
// FOOTER

// ANIMATE SCROLL

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      console.log(entry.target.classList);
      if(entry.target.classList.contains("category-images")){
        entry.target.classList.add('category-images__animate');
        setTimeout(() => {
          entry.target.style.setProperty("transform", "scale(1)");
          entry.target.classList.remove('category-images__animate');
        }, 1000);
      }

      observer.unobserve(entry.target);
    } else {
      // entry.target.classList.remove('is-visible');
    }
  });
}, {
  root: null,     
  rootMargin: '0px 0px -10% 0px',
  threshold: 0.15     
});

document.querySelectorAll('.animate-on-scroll').forEach((el) => {
  observer.observe(el);
});

// ANIMATE SCROLL

// CATEGORY SLIDESHOW ANIMATE


const collectionLinkSectionInit = () => {

   const collectionLinkSection = document.querySelector("collection-links-component");
   const imageWrapper = document.createElement("div");
   const imageElement = document.createElement("img");
   const selectedSlide = document.querySelector("collection-links-component > slideshow-component > slideshow-container > slideshow-slides > slideshow-slide[aria-hidden='false'] img");
   imageElement.src = selectedSlide.src;
   imageElement.id = 'collectionlinkSection__img';
   imageWrapper.appendChild(imageElement);
   collectionLinkSection.appendChild(imageWrapper);

}

collectionLinkSectionInit();

const categoryLinkHover = e => {
  const selectedSlide = document.querySelector("collection-links-component > slideshow-component > slideshow-container > slideshow-slides > slideshow-slide[aria-hidden='false'] img");
  console.log(selectedSlide);
  if(selectedSlide){
    const selectedSliderSrc = selectedSlide.src;
    document.querySelector("#collectionlinkSection__img").src = selectedSliderSrc;
  }
}